export class PlantIdRequest{
    unitcodeId : number;
    financialYear?: string;

      constructor(unitcodeId : number, financialYear?: string) {
        this.unitcodeId = unitcodeId;
        this.financialYear = financialYear;
    }

}